import { ApiPlatform } from '@/api/types';

export function mapAssetPlatform<T extends { platform: string }>(asset: T): T {
  return { ...asset, platform: asset.platform === 'PFX' ? ApiPlatform.FX : asset.platform };
}
